(function () {
  var body = document.querySelector('.shopify-policy__body');
  if (!body) return;

  var replacements = [
    [/\byummygummy\b/g, 'Yummy Gummy'],
    [/faizanraza934@gmail\.com/g, 'info@soislifesciences.com'],
    [/Last updated:\s*July 17,\s*2026/g, 'Last updated: July 26, 2026']
  ];

  function updateTextNode(node) {
    var value = node.nodeValue;
    replacements.forEach(function (pair) {
      value = value.replace(pair[0], pair[1]);
    });
    node.nodeValue = value;
  }

  var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
  var nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach(updateTextNode);

  body.querySelectorAll('a[href^="mailto:"]').forEach(function (link) {
    if (link.href.indexOf('faizanraza934') !== -1) {
      link.href = 'mailto:info@soislifesciences.com';
    }
  });

  var contactHeading = Array.prototype.find.call(body.querySelectorAll('h2, h3'), function (heading) {
    return heading.textContent.trim().toLowerCase() === 'contact';
  });
  if (contactHeading && !body.querySelector('.yg-policy-brand-note')) {
    var contactParagraph = contactHeading.nextElementSibling;
    if (contactParagraph && contactParagraph.tagName === 'P') {
      var brandNote = document.createElement('span');
      brandNote.className = 'yg-policy-brand-note';
      brandNote.innerHTML = ' Yummy Gummy is operated as <a href="http://soislifesciences.com/" target="_blank" rel="noopener">Yummy Gummy by Sois Life Sciences</a>, with website development and design by <a href="https://tagcode.com.pk/" target="_blank" rel="noopener">TagCode</a>.';
      contactParagraph.appendChild(brandNote);
    }
  }
})();
